//@flow

export const LOAD_VIDEOS_DETAILS: string = 'loadVideosDetails';
export const LOAD_VIDEOS_DETAILS_SUCCESS: string = 'loadVideosDetailsSuccess';
export const LOAD_VIDEOS_DETAILS_FAIL: string = 'loadVideosDetailsFail';

export const LOAD_VIDEO_TRACK: string = 'loadVideoTrack';
export const LOAD_VIDEO_TRACK_SUCCESS: string = 'loadVideoTrackSuccess';
export const LOAD_VIDEO_TRACK_FAIL: string = 'loadVideoTrackFail';

export const DELETE_VIDEO: string = 'deleteVideo';
export const DELETE_VIDEO_SUCCESS: string = 'deleteVideoSuccess';
export const DELETE_VIDEO_FAIL: string = 'deleteVideoFail';

export const SET_SELECTED_VIDEO_INDEX: string = 'setSelectedVideoIndex';
export const VIDEOS: string = 'videos';
export const VIDEO_TRACK: string = 'videoTrack';
export const FLIGHT_ID: string = 'projectId';
export const SELECTED_VIDEO_INDEX: string = 'selectedVideoIndex';
export const ERROR: string = 'videoRelatedError';
export const CLEAR_ERROR: string = 'clearVideoRelatedError';

export const IS_STREAM_TRANSMITING: string = 'isStreamTransmiting';
export const SET_STREAM_TRANSMITING: string = 'setStreamTransmiting';
export const HLS_URL: string = 'hlsUrl';

export type VideoMetaData = {
  beginDateTime: string,
  createdByUserId: number,
  createdDateTime: string,
  duration: number,
  fileName: string,
  projectId: number,
  id: number,
  modifiedByUserId: number,
};

export type VideoAction = {
  type: string,
  axiosInstance?: any,
  projectId?: number,
  error?: string,
  index?: number,
  videos?: Array<VideoMetaData>,
  videoTrack: Array<Object>
};

export type VideoProps = {
  title: String,
  loadVideosDetails: (axiosInstance: any, projectId: number) => {},
  videos: Array<VideoMetaData>,
  projectId: number,
  axiosInstance: any,
  chosenFlight: any,
  selectedVideoIndex: number | null,
  setSelectedVideoIndex: (index: number | null) => void,
  deleteVideo: (index: number) => void,
  clearError: () => void,
};




// WEBPACK FOOTER //
// ./src/types/video.jsx